<template>
  <div>
    <!-- titleHidden keeps the heading's height so a side-by-side pair stays level, without
         repeating the measure name over both tables. -->
    <h2 v-if="data.title" class="mt-4" :class="{ invisible: data.titleHidden }">{{ data.title }}</h2>
    <p v-if="data.subtitle">{{ data.subtitle }}</p>
    <b-table-simple v-if="data.cols" small hover :class="data.classes">
      <b-thead>
        <b-tr>
          <b-th style="width:25%"><h3>{{ data.firstRowHeader }}</h3></b-th>
          <b-th>{{ data.secondRowHeader }}</b-th>
          <b-th v-for="(col, index) in data.cols" class="text-right small" :key="index"><strong>{{ col }}</strong></b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="row in data.rows">
          <template v-if="row.subRows"><!-- nested rows with header data/rowspan -->
            <tr v-for="subRow, index in row.subRows">
              <b-th v-if="index == 0" :rowspan="row.subRows.length" :class="subRow.class || ''" v-html="row.title"></b-th>
              <b-th :class="subRow.class || ''">{{ subRow.title }}</b-th>
              <b-td v-for="stat in subRow.data" :class="'text-right ' + (subRow.class || '')" :key="index" v-html="stat || '–'"></b-td>
            </tr>
          </template>
          <template v-else><!-- simple rows -->
            <tr>
              <b-th :class="row.class || ''">{{ row.title }}</b-th>
              <b-td :class="row.class || ''"></b-td>
              <b-td v-for="(stat, index) in row.data" :class="'text-right ' + (row.class || '')" :key="index" v-html="stat || '–'"></b-td>
            </tr>
          </template>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: 'MioTable',
  props: {
    data: Object,
  },
}
</script>
